import { track } from "@amplitude/analytics-react-native";
import { memo } from "react";
import { View } from "react-native";
import OpacityView from "src/components/OpacityView";
import PillButton from "src/components/PillButton";
import IconPause from "src/icons/IconPause";
import IconPlay from "src/icons/IconPlay";
import { enumNever } from "src/shared/helpers/generalHelpers";
import useAudioPlayerStore from "src/stores/useAudioPlayerStore";
import { paddingSmall } from "src/styles/spacing";
import { AnimatePresence, Image } from "src/swsh-native";

const iconSize = 16;
const imageSize = 24;
const GatheringHomeAudioPlayerDisplayContent = ({ thumbnailUrl }: { thumbnailUrl: string }) => {
	const status = useAudioPlayerStore((state) => state.status);
	const setStatus = useAudioPlayerStore((state) => state.setStatus);

	return (
		<PillButton
			key="AudioPlayerDisplay"
			testID="AudioPlayerDisplay"
			opaque
			onPress={() => {
				switch (status) {
					case "playing": {
						track("gathering_audioPlayer_pause");
						setStatus("paused");
						break;
					}
					case "paused": {
						track("gathering_audioPlayer_play");
						setStatus("playing");
						break;
					}
					default: {
						return enumNever(status);
					}
				}
			}}
		>
			<View
				style={{
					flexDirection: "row",
					alignItems: "center",
					gap: paddingSmall,
				}}
			>
				<Image
					alt="Audio thumbnail"
					src={thumbnailUrl}
					dim={{
						width: imageSize,
						height: imageSize,
					}}
					style={{
						borderRadius: 4,
					}}
				/>
				<View
					style={{
						width: iconSize,
						height: iconSize,
					}}
				>
					<AnimatePresence>
						<OpacityView
							key={status}
							duration={100}
							style={{
								position: "absolute",
							}}
						>
							{status === "paused" ? (
								<IconPlay size={iconSize} />
							) : (
								<IconPause size={iconSize} />
							)}
						</OpacityView>
					</AnimatePresence>
				</View>
			</View>
		</PillButton>
	);
};
const MemoedGatheringHomeAudioPlayerDisplayContent = memo(GatheringHomeAudioPlayerDisplayContent);

const GatheringHomeAudioPlayerDisplay = () => {
	const currentAudio = useAudioPlayerStore((state) => state.currentAudio);

	if (!currentAudio) return null;
	return (
		<MemoedGatheringHomeAudioPlayerDisplayContent thumbnailUrl={currentAudio.thumbnailUrl} />
	);
};
export default GatheringHomeAudioPlayerDisplay;
